import { z } from 'zod'

export const loginSchema = z.object({
  email: z.string().email('Введите корректный email'),
  password: z.string().min(6, 'Пароль должен содержать минимум 6 символов'),
})

export const dailyLogSchema = z.object({
  date: z.string().min(1, 'Выберите дату'),
  content: z.string().min(10, 'Описание должно содержать минимум 10 символов'),
})

export const weeklySummarySchema = z.object({
  week_start_date: z.string().min(1, 'Выберите дату начала недели'),
  plan_content: z.string().optional(),
  execution_status: z.string().optional(),
  achievements: z.string().optional(),
  challenges: z.string().optional(),
})

export const feedbackSchema = z.object({
  weekly_summary_id: z.number().positive(),
  content: z.string().min(5, 'Минимум 5 символов'),
})

export const departmentSchema = z.object({
  name: z.string().min(2, 'Название отдела должно быть не менее 2 символов'),
  parent_department_id: z.number().optional().nullable(),
  director_id: z.number().optional().nullable(),
})
